window.addEventListener('DOMContentLoaded', () => {
  const stickyATC = document.querySelector('#lumin-sticky-atc');
  if (!stickyATC) return;

  const img = stickyATC.querySelector('.product-content img');
  const selectField = stickyATC.querySelector('select[name="id"]');
  const mainSelect = document.querySelector('.product-form [name="id"]');
  
  // Show sticky ATC immediately on page load
  stickyATC.classList.add('show');
  document.documentElement.style.paddingBottom = `${stickyATC.clientHeight}px`;
  document.documentElement.style.height = 'auto';

  // Update sticky image when variant changes from sticky select
  if (selectField) {
    selectField.addEventListener('change', () => {
      const newImg = selectField.options[selectField.selectedIndex].dataset.img;
      if (newImg) img.setAttribute('src', newImg);
    });
  }

  // Sync sticky variant select with main product form variant select
  if (mainSelect && selectField) {
    mainSelect.addEventListener('change', (e) => {
      selectField.value = e.target.value;
      const newImg = selectField.options[selectField.selectedIndex].dataset.img;
      if (newImg) img.setAttribute('src', newImg);
    });
  }
});
